const AllDepartments = () => import("../department/views/AllDepartments.vue");
const DepartmentForm = () => import("../department/views/DepartmentForm.vue");
const EditDepartment = () => import("../department/views/EditDepartment.vue");

export default [
  {
    path: "view-all",
    component: AllDepartments,
  },
  {
    path: "edit/:id",
    component: EditDepartment,
  },
  {
    path: "create",
    component: DepartmentForm,
  },
];
